import {Component, EventEmitter, OnInit} from 'angular2/core';

import {NgIf, NgClass} from 'angular2/common';

/*
    This component is a generic bootstrap alert, used to display information like success or error event.
    It is used to provide feedback to users when they perform actions.
 */

@Component({
    selector: 'alert',
    properties: ['type', 'closeable', 'dismissOnTimeout: dismiss-on-timeout'],
    events: ['close'],
    templateUrl: `./app/components/common/alerts/alert.html`,
    directives: [NgIf, NgClass]
})
export class AlertComponent implements OnInit {
    type:string;
    closeable:boolean;
    close:EventEmitter<any> = new EventEmitter<any>();
    templateUrl:string;
    dismissOnTimeout:number;
    private closed:boolean;
    private classes:Array<string> = [];

    constructor() {
    }

    ngOnInit() {
        if (this.closeable === undefined) {
            this.closeable = true;
        }
        this.type = this.type || 'warning';
        this.classes[0] = 'alert-' + (this.type || 'warning');
        if (this.closeable) {
            this.classes[1] = 'alert-dismissible';
        } else {
            this.classes.length = 1;
        }

        if (this.dismissOnTimeout) {
            let close = this.onClose.bind(this);
            setTimeout(close, this.dismissOnTimeout);
        }
    }

    onClose($event:MouseEvent) {
        this.close.emit($event);
        this.closed = true;
    }
}